/**
* *
* RRA_PC_01
*/
import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as $ from 'jquery';
import swal from 'sweetalert';
import * as MenuAction from './MenuAction';
/*
 * RRA_PC_02
 * */
const RTVPageLoadAction = (BO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.RTVItems,
            SDIConstants.methodNames.RTVPageload,
            JSON.stringify(BO),

            (data) => {
                if (data.success) {
                    //;
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.RTVPageload, response: data.response };
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        //;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
/**
 * RRA_PC_03
 * */
const SaveRTVAction = (BO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.RTVItems,
            SDIConstants.methodNames.RTVSaveLines,
            JSON.stringify(BO),

            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.RTVSaveLines, response: data.response };
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        //swal({
                        //    allowOutsideClick: false,
                        //    closeOnClickOutside: false,
                        //    text: contentData.response
                        //});
                        $(`#Success-popup`).modal('show')
                        $(`#RMASucessMessage`).text(contentData.response);
                        //alert(`${contentData.response}`);
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const insertFavPage = async (insertFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_InsertFavPage,
            JSON.stringify(insertFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ORDERSTS_InsertFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const deleteFavPage = async (deleteFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_DeleteFavPage,
            JSON.stringify(deleteFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ORDERSTS_DeleteFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const getCurrentFavPage = async (getFavPageBO) => {
    try {
        SDISVC.callRecurringGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_GetCurrentFavPage,
            JSON.stringify(getFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ORDERSTS_CurrentFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
export {
    RTVPageLoadAction, SaveRTVAction, insertFavPage, deleteFavPage, getCurrentFavPage
}